import { MimeTypes } from "./MimeTypes";

export interface GDriveFile {
  id: string;
  name: string;
  mimeType: MimeTypes;
  createdTime: string;
  size?: string;
}

// all keys from GDriveFile src/app/components/AddRecord/GoogleDrive/types/GDriveFile.ts:3
export const FIELDS = [
  "id",
  "name",
  "mimeType",
  "createdTime",
  "size",
];
